import { render } from "./ItemProfileOffChainOfferList.vue?vue&type=template&id=51cd85c1&scoped=true"
import script from "./ItemProfileOffChainOfferList.vue?vue&type=script&lang=ts"
export * from "./ItemProfileOffChainOfferList.vue?vue&type=script&lang=ts"

import "./ItemProfileOffChainOfferList.vue?vue&type=style&index=0&id=51cd85c1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51cd85c1"

export default script